import React, { Component } from "react";
import { Link } from "react-router-dom";
import AddToCartBtn from "../micro/AddToCartBtn";
import ChangeQuantityBtn from "../micro/ChangeQuantityBtn";
import Image from "../micro/Image";
import { navigate_to_product } from "../../../navigator/user/product";

export default class ProductCard extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  quantity_changed(data) {
    this.props.quantityChanged(data);
  }
  render() {
    return (
      <div className="container-fluid px-0 position-relative">
        {this.props.product && (
          <Link
            className="position-absolute"
            style={{
              top: "0",
              bottom: "0",
              left: "0",
              right: "0",
              zIndex: "2",
            }}
            to={navigate_to_product(
              this.props.product.shop
                ? this.props.product.shop.uid
                : this.props.shopUid && this.props.shopUid,
              this.props.product.product_id || this.props.product.id,
              this.props.isDashboard
            )}
          />
        )}
        <div
          className={`row mx-0 ${
            this.props.rowsCount === 2 ? "px-3" : "px-4"
          } py-3 position-relative`}
        >
          <div
            className={`${
              this.props.rowsCount === 2 ? "col-12 px-0" : "col-4 ps-2 pe-0"
            } align-self-center position-relative`}
          >
            <Image
              type={"product"}
              extraClassName={"p-3 bg-color-main w-100 rounded14"}
              imgClassName={"w-100 rounded14 img-cover"}
              imageHeight={this.props.rowsCount === 2 ? "145" : "100"}
              imageAlt={"product-image"}
              imageUri={
                this.props.image && this.props.image.thumbnail
                  ? this.props.image.thumbnail
                  : this.props.product.image &&
                    this.props.product.image.thumbnail
              }
            />
            {this.props.product &&
              (this.props.product.discount_str ||
                (this.props.product.discount &&
                  !this.props.product.discount.title)) && (
                <span
                  className="rounded14 fs-7 text-white bg-danger d-inline-block position-absolute"
                  style={{ padding: "2px 7px", top: "10px", right: "10px" }}
                >
                  {this.props.str
                    ? this.props.product.discount_str
                    : this.props.product.discount}
                </span>
              )}
          </div>

          <div
            className={`col px-0 align-self-center ${
              this.props.rowsCount === 2 ? "pt-2" : ""
            }`}
          >
            <p className="small mb-0 fw">
              {this.props.name || this.props.product.name}
            </p>
            {this.props.product &&
            ((this.props.product.discount && !this.props.payable_price) ||
              (this.props.str && this.props.product.discount_str)) ? (
              <div>
                {this.props.product.has_stock && (
                  <div className="fs-7">
                    <span
                      className="rounded14 p-1 me-1 d-inline-block"
                      style={{
                        textDecoration: "line-through",
                        color: this.props.str
                          ? this.props.product.price_str.color
                          : this.props.product.price.color,
                      }}
                    >
                      {this.props.str
                        ? this.props.product.price_str.title
                        : this.props.product.price.title}
                      <span className="fs-7 me-1">
                        {this.props.str
                          ? this.props.product.price_str.currency
                          : this.props.product.price.currency}
                      </span>
                    </span>
                  </div>
                )}
                <p
                  className="fs-6 fw-bold mb-0 mt-1"
                  style={{
                    color: this.props.str
                      ? this.props.product.payable_price_str.color
                      : this.props.product.payable_price.color,
                  }}
                >
                  {this.props.str
                    ? this.props.product.payable_price_str.title
                    : this.props.product.payable_price.title}
                  <span className="fs-7 me-1">
                    {this.props.str
                      ? this.props.product.payable_price_str.currency
                      : this.props.product.payable_price.currency}
                  </span>
                </p>
              </div>
            ) : (
              <p
                className="fs-6 fw-bold mb-0 mt-2"
                style={{
                  color: this.props.payable_price
                    ? this.props.payable_price.color
                    : this.props.product.payable_price.color,
                }}
              >
                {this.props.payable_price
                  ? this.props.payable_price.title
                  : this.props.product.payable_price.title}
                <span className="fs-7 me-1">
                  {this.props.payable_price
                    ? this.props.payable_price.currency
                    : this.props.product.payable_price.currency}
                </span>
              </p>
            )}
          </div>
          <div
            className="col-auto px-0 align-self-end position-absolute"
            style={{ zIndex: "3", left: "18px" }}
          >
            <div>
              {this.props.quantity &&
                !this.props.isOrder &&
                this.props.product.has_stock && (
                  <ChangeQuantityBtn
                    quantity={this.props.quantity}
                    product={this.props.product}
                    shopUid={this.props.shopUid}
                    cartMode={this.props.cartMode}
                    quantityChanged={(product) =>
                      this.quantity_changed(product)
                    }
                  />
                )}
              {this.props.quantity && this.props.isOrder && (
                <p className="fs-6 fw-bolder">
                  {this.props.quantity}
                  <span className="me-1">عدد</span>
                </p>
              )}
              {!this.props.quantity &&
                this.props.product.has_stock &&
                !this.props.hideAddBtn &&
                !this.props.str &&
                this?.props?.onlineOrdering?.online_ordering && (
                  <AddToCartBtn
                    product={this.props.product}
                    shopUid={this.props.shopUid}
                    onlineOrdering={
                      this?.props?.onlineOrdering?.online_ordering
                    }
                  />
                )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
